<h2>{{'claims-center.audanetIntegration.partsInfo' | translate}}</h2>
<kendo-grid [data]="calculation.audanetCalculationParts" [size]="'small'">

    <kendo-grid-column field="description" title="{{'claims-center.audanetIntegration.partDescription' | translate}}"
        [width]="25">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.description}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="partIdentifier" title="{{'claims-center.audanetIntegration.partIdentifier' | translate}}"
        [width]="25">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.partIdentifier}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="quantity" title="{{'claims-center.audanetIntegration.quantity' | translate}}"
        [width]="25">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.quantity | number : '1.2-2' }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="price" title="{{'claims-center.audanetIntegration.price' | translate}}" [width]="25">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.price | number : '1.2-2' }}
        </ng-template>
    </kendo-grid-column>

</kendo-grid>